module.exports = __webpack_public_path__ + "assets/img/JD.ab5191a8.png";